import React, { Component } from "react";
import { Collapse, Icon, Button } from "@blueprintjs/core";
import UISelect from "../../components-fm/UISelect";
import { PLAYERS_TRAINING_STATUS } from '../../utils/constants';

export default class PlayersSidebar extends Component {
    renderSection = (label, key, list) => {
        console.log(list)
        const { collapsed, onToggleColl, onChangeStatus } = this.props;
        return (
            <div className="sidebar-section">
                <div
                    className="section-header"
                    onClick={() => onToggleColl(key)}
                >
                    <span className="f-5">{label} </span>
                    <span className="f-5">{list.length}</span>
                </div>

                <Collapse isOpen={!collapsed[key]}>
                    {list.map((p, idx) => (
                        <div key={p.id} className="l1-list-item">
                            <UISelect
                                items={PLAYERS_TRAINING_STATUS}
                                onItemSelect={(selectedStatus) => onChangeStatus(p.id, selectedStatus.key)}
                                placeholder="Status"
                                button={
                                    <div className='fm-f-row'>
                                        <span className="f-3">{idx + 1}.</span>
                                        <span className="f-4">{p.name}</span>
                                        {p.default_status === "accidentat" && <Icon icon='symbol-cross' size='22' />}
                                        {p.default_status === "suspendat" && <Icon icon="blocked-person" size='16' />}
                                    </div>
                                }
                            />
                            {p.status === 'accidentat' && <Icon icon="plus" size={22} />}
                        </div>
                    ))}
                </Collapse>
            </div>
        );
    };

    copyPlayersToClipboard = () => {
        const { players = [], training } = this.props;

        // 1) Antet: "Antrenament {ZiuaSăptămânii}"
        const weekdayRo = training?.event_date
            ? new Intl.DateTimeFormat('ro-RO', { weekday: 'long' }).format(new Date(training.event_date))
            : '';
        const ziua = weekdayRo ? (weekdayRo.charAt(0).toUpperCase() + weekdayRo.slice(1)) : '—';

        // 2) Filtrăm doar participanții (status 'active' sau necompletat)
        const active = players.filter(p => p.status === 'active' || !p.status);

        // 3) GK primii, apoi ceilalți — ambele grupe sortate desc. după vârstă (data nașterii mai mică => mai bătrân)
        const posOf = p => (p.position || p.default_position || '').toUpperCase();
        const byAgeDesc = (a, b) => new Date(a.birth_date) - new Date(b.birth_date); // mai vechi (mai bătrân) primul

        const gk = active.filter(p => posOf(p) === 'GK').sort(byAgeDesc);
        const field = active.filter(p => posOf(p) !== 'GK').sort(byAgeDesc);

        const sorted = [...gk, ...field];

        // 4) Conținutul listei
        const lista = sorted.map((p, i) => `${i + 1}. ${p.name}`).join('\n');

        // 5) Footer: "Ora {HH:MM} prezenta la {locație}"
        const ora = training?.event_time || '—';
        const loc = training?.location || '—';

        const text = `Antrenament ${ziua}:\n${lista}\n\nOra ${ora} prezenta la ${loc}`;

        navigator.clipboard.writeText(text);
    };





    render() {
        const { players, collapsed, sidebarOpen, onToggleAll, training } = this.props;
        const active = players.filter(p => p.status === "active" || !p.status);
        const injured = players.filter(p => p.status === "accidentat");
        const absent = players.filter(p => p.status === "absent");
        const excused = players.filter(p => p.status === "invoit");
        const unselected = players.filter(p => p.status === "neconvocat");
        console.log('training.4444444444', training)
        return (
            <div className="all-players-col">
                {sidebarOpen && (
                    <div className="sidebar-content">
                        <button class="uecl-button"
                            onClick={() => this.copyPlayersToClipboard()}
                            title="Copiază jucătorii">
                            Copy
                            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11 2c0-.55-.45-1-1-1h.22C9.88.4 9.24 0 8.5 0S7.12.4 6.78 1H7c-.55 0-1 .45-1 1v1h5V2zm2 0h-1v2H5V2H4c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z" />
                            </svg>
                        </button>

                        {this.renderSection("Participă", "active", active)}
                        {this.renderSection("Accidentați", "injured", injured)}
                        {this.renderSection("Absenți", "absent", absent)}
                        {this.renderSection("Învoiți", "excused", excused)}
                        {this.renderSection("Neconvocați", "unselected", unselected)}
                    </div>
                )}

            </div>
        );
    }
}
